import { getJSON } from 'common/services/api'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { useQuery } from 'react-query'
import type { TodayMonitoring } from '../types'
import {
  TODAY_MONITORING_QUERY_KEY,
  TODAY_MONITORING_URL
} from './queryConstants'

type UseTodayMonitoringReturn = {
  todayMonitoring: TodayMonitoring | undefined
  isTodayMonitoringLoading: boolean
}

const useTodayMonitoring = (): UseTodayMonitoringReturn => {
  const flags = useFeatureFlags({
    flagNames: ['rostering_parked_features']
  })?.data

  const flagsRosteringParkedFeaturesEnabled =
    flags?.rostering_parked_features?.enabled

  const { data: todayMonitoring, isLoading: isTodayMonitoringLoading } =
    useQuery([TODAY_MONITORING_QUERY_KEY], () =>
      getJSON({
        url: TODAY_MONITORING_URL,
        isRota: true
      })
    )

  if (
    !flagsRosteringParkedFeaturesEnabled &&
    todayMonitoring?.warnings?.genderMismatch
  ) {
    delete todayMonitoring?.warnings?.genderMismatch
  }

  return {
    todayMonitoring,
    isTodayMonitoringLoading
  }
}

export default useTodayMonitoring
